import React from 'react';
import { addMany as addManyToCartService } from '../Services/Cart.service';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import EnhancedBuyButton from './EnhancedBuyButton';
import { updateQuantityInput } from '../Actions/QuantityInput.action';

const BuyMultipleButton = ({ mode, href, clearFavouriteList }) => {
    const dispatch = useDispatch();

    const quantityFields = useSelector((state) => {
        return state.quantityInput.quantityFields;
    });
    const { isActiveOrganization } = useSelector((state) => state.myPage);
    const quantityFieldsWithValues = Object.values(quantityFields).filter(
        (item) => item.value > 0 && item.includeInMultiPurchase
    );
    const isActive = quantityFieldsWithValues.length >= 1;

    const onClickHandler = async ({ variantData }) => {
        try {
            const cart = await addManyToCartService(variantData);
            dispatch(receive(cart));
            if (clearFavouriteList) {
                clearFavouriteList();
            }
            window.QuantityCheckDialogContinue = true;
            if (href) {
                window.location.href = href;
            }
            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };

    const disabledTooltip = !isActive
        ? translate('code.product.buymultiple.notallowed')
        : !isActiveOrganization
            ? translate('code.organization.inactive')
            : null;

    return (
        <EnhancedBuyButton
            cssClass={`button button--cta button--short button--extra-padding buy-multiple-button ${!isActive || !isActiveOrganization ? 'button--not-allowed' : ''
                }`}
            disabledTooltip={disabledTooltip}
            label={
                mode === 'mobile'
                    ? translate('code.product.buymultiple.mobile')
                    : translate('code.product.buymultiple')
            }
            disabled={!isActive || !isActiveOrganization}
            siteLoader
            stylePrefix="buy-button"
            visuallyDisabled={!isActive || !isActiveOrganization}
            onClick={() => {
                if (isActive && isActiveOrganization) {
                    const variantData = quantityFieldsWithValues.map((x) => ({
                        articleNumber: x.variantId,
                        quantity: x.value,
                    }));
                    return onClickHandler({ variantData });
                } else {
                    return false;
                }
            }}
            onClickFinished={(e) => {
                for (let quantityField of quantityFieldsWithValues) {
                    dispatch(updateQuantityInput({ ...quantityField, value: '' }));
                }
            }}
        />
    );
};

export default BuyMultipleButton;
